import FarmDeliveries from 'admin/components/FarmDeliveries';

export const FarmDeliveriesPage = () => {
  return <FarmDeliveries showPageLayout={true} />;
};
